import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { updateCart } from 'redux/actions/cart.actions';
import { cartSizeSelector, cartSubtotalSelector, cartSubtotalTextilSelector } from 'redux/selectors/cart.selector';
import { formatCurrencyARS } from 'helpers/currency';
import './CartDrawer67.scss';

const CartDrawer67 = ({ open, onClose, items, products, cartSize, total, client, updateCartAction }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;
  const lines = (items || []).map((row, index) => {
    const product = (products || []).find((item) => Number(item.id) === Number(row.itemId));
    if (!product) return null;
    const variant = product.stock_product_descriptions?.find((description) => Number(description.id) === Number(row.descriptionId));
    const price = variant?.price > 0 ? variant.price : (product.sale || product.price || 0);
    return (
      <article className="cart67-line" key={`${row.itemId}-${row.descriptionId || 'base'}-${index}`}>
        <img src={product.image1 || product.image || ''} alt="" />
        <div className="cart67-line__info">
          <Link to={`/producto/${product.code || product.id}`} onClick={onClose}>{product.name}</Link>
          <span>{row.quantity} × {formatCurrencyARS(price)}</span>
          {variant?.stock_descriptions?.name && <small>{variant.stock_descriptions.name}</small>}
        </div>
        <button type="button" aria-label={`Quitar ${product.name}`} onClick={() => updateCartAction(row.itemId, 0, row.descriptionId ?? null, row.wholesale ?? null, null)}>×</button>
      </article>
    );
  }).filter(Boolean);

  return (
    <div className="cart67-overlay" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <aside className="cart67-drawer" role="dialog" aria-modal="true" aria-labelledby="cart67-title">
        <div className="cart67-drawer__header">
          <div><h2 id="cart67-title">Tu carrito</h2><span>{cartSize} {cartSize === 1 ? 'producto' : 'productos'}</span></div>
          <button type="button" aria-label="Cerrar carrito" onClick={onClose}>×</button>
        </div>
        {!lines.length ? (
          <div className="cart67-empty"><span aria-hidden="true">♡</span><h3>Tu carrito está vacío</h3><p>Encontrá algo especial para vos o para regalar.</p><button type="button" onClick={onClose}>Seguir comprando</button></div>
        ) : (
          <>
            <div className="cart67-drawer__items">{lines}</div>
            <div className="cart67-drawer__footer">
              <div className="cart67-subtotal"><span>Subtotal</span><strong>{formatCurrencyARS(total)}</strong></div>
              <p>El envío y los descuentos se calculan al continuar.</p>
              <Link className="cart67-checkout" to="/carrito" onClick={onClose}>Revisar carrito y continuar</Link>
              <button className="cart67-continue" type="button" onClick={onClose}>Seguir comprando</button>
            </div>
          </>
        )}
      </aside>
    </div>
  );
};

CartDrawer67.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape()),
  products: PropTypes.arrayOf(PropTypes.shape()),
  cartSize: PropTypes.number,
  total: PropTypes.number,
  client: PropTypes.shape(),
  updateCartAction: PropTypes.func.isRequired,
};

export default connect((state) => ({
  items: state.cart.items,
  products: state.cart.products,
  cartSize: cartSizeSelector(state),
  total: Number(state.app.client?.design) === 3 ? cartSubtotalTextilSelector(state) : cartSubtotalSelector(state),
  client: state.app.client,
}), (dispatch) => ({ updateCartAction: bindActionCreators(updateCart, dispatch) }))(CartDrawer67);
